<script>
  import { router } from './lib/router.js';
  import { routes } from './lib/routes.js';
  import Layout from './components/layout/Layout.svelte';
  import Analytics from './components/common/Analytics.svelte';

  $: CurrentPage = routes[$router.path] || routes['/'];
</script>

<Analytics />
<Layout>
  <svelte:component this={CurrentPage} />
</Layout>

<style>
</style>
